import {createLogger} from '../../common/logging.config';
const logger = createLogger('publishing-preferences-filter');

module.exports = [function() {

    // Filter the publishing job entries based on the current preferences setting
    return function(entries, preferences, userId) {
    	// only use this filter for my publishing events versus all publishing events
		let userPreferences = {onlyMyEvents: true, maxDaysToShow: 99999, maxEventsToShow: 99999};
		//let userPreferences = {onlyMyEvents: true, maxDaysToShow: 5, maxEventsToShow: 8};
		if (preferences && Object.keys(preferences).length > 0) {
			userPreferences.onlyMyEvents = preferences.onlyMyEvents;
			//userPreferences = preferences;
		}
        let filteredEntries = []; // NOSONAR, not constant

        entries.forEach((entry) => {
        	// test if only showing entries for this user
        	let shouldSkip = false;
        	if (userId && userPreferences.onlyMyEvents === true) {
        		// remove all body entries not created by this user 
        		for (let index = entry.body.length - 1; index >= 0 ; index--) {
        			if (userId !== entry.body[index].bodyEntryCreatorId) {
        				entry.body.splice(index, 1);
        			}
        		}
        		// if we removed all body entries, then skip this entry altogether
        		if (entry.body.length === 0) {
        			shouldSkip = true;
        		}
        		
        	}
        	if (shouldSkip === false) {
            	// each entry corresponds to one day
            	if (filteredEntries.length < userPreferences.maxDaysToShow) {
            		
            		// ensure the body array with the events is below the pref setting
            		entry.body = entry.body.slice(0, userPreferences.maxEventsToShow);
            		
            		filteredEntries.push(entry);
            	}
        	} 
        });

        return filteredEntries;
    }

}];



// WEBPACK FOOTER //
// ./app/common/services/publishing-preferences.filter.js